import React from 'react';
import { css } from 'emotion';

const padWithZero = num => (num > 9 ? `${num}` : `0${num}`);
const convertSecondToTime = seconds => {
  const min = Math.floor(seconds / 60);
  const remainingSeconds = seconds - min * 60;
  return `${padWithZero(min)}:${padWithZero(remainingSeconds)}`;
};

export default ({ reset, toggleTimer, timer, started }) => {
  return (
    <div
      className={css`
        color: var(--presentation-color-body);
        position: fixed;
        bottom: 1rem;
        right: 1rem;
        display: flex;
        align-items: baseline;
      `}
    >
      {!started && timer > 0 && (
        <span
          className={css`
            margin-right: 0.5em;
            cursor: pointer;
            color: #aaa;
          `}
          onClick={reset}
        >
          reset
        </span>
      )}
      <span
        className={css`
          text-decoration: ${started ? 'none' : 'underline'};
          cursor: pointer;
        `}
        onClick={toggleTimer}
      >
        {timer > 0
          ? convertSecondToTime(timer)
          : started
          ? convertSecondToTime(timer)
          : 'start'}
      </span>
    </div>
  );
};
